export default __webpack_public_path__ + "media/color/uma-13e117ba.svg";